/**
 *
 * WidgetBox
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    boxShadow: 'none !important',
    border: '1px solid #E9ECED',
    marginBottom: 30,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  content: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 16,
    },
  },
});

function WidgetBox(props) {
  const { classes, children } = props;
  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>{children}</CardContent>
    </Card>
  );
}

WidgetBox.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
};

export default withStyles(styles)(WidgetBox);
